module.exports = __webpack_public_path__ + "static/media/logo512.e1e9f5da.png";